import { render, staticRenderFns } from "./NewTranscriptions.vue?vue&type=template&id=7ace6a04&scoped=true"
import script from "./NewTranscriptions.vue?vue&type=script&lang=js"
export * from "./NewTranscriptions.vue?vue&type=script&lang=js"
import style0 from "./NewTranscriptions.vue?vue&type=style&index=0&id=7ace6a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace6a04",
  null
  
)

export default component.exports